import  { useCallback, useEffect } from 'react'
import { checkTokenValidity, clearLocalStorage, getLocalStorage, getURLSearchParamsValue, getUserDetails, setLocalStorage, silentLogin, userVerify } from '../utils/Utils';
import { CUSTOM_STORE, PARAMS_NAME, REACT_APP_SWAN_API_SERVER_URL, STORAGE_KEY } from '../services/constant';

const useGetParams = (attributesData,setDetails) => {
    const { shopDomain, product, addToCart,name,email } = attributesData ?? {};
	
    const initializeAttributesData = useCallback(async () => {
	let jwtToken = getLocalStorage(STORAGE_KEY.JWTToken);
	let scanId = getLocalStorage(STORAGE_KEY.SCAN_ID);
	let userEmail = email;
		if (!attributesData) return;
		if (shopDomain && product?.handle) {
			if ([CUSTOM_STORE.HOUSE_OF_ALDENO, CUSTOM_STORE.SWAN_CUSTOM_STORE_STAGING].includes(shopDomain)) {
				if (jwtToken) {
				  if (checkTokenValidity(jwtToken, email)) {
					await getUserDetails(email);
				  } else {
					clearLocalStorage();
					await silentLogin({email, userName:name,shopDomain});
				  }
				} else if (email) {
				  await silentLogin({email, userName:name,shopDomain})
				}
			  } 
			const searchParams = getURLSearchParamsValue(window.location.search);			
			if (searchParams.has(PARAMS_NAME.SCAN_ID) && searchParams.get(PARAMS_NAME.SCAN_ID) !== "null") {
				scanId = searchParams.get(PARAMS_NAME.SCAN_ID);
				setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
			} else {
				scanId = getLocalStorage(STORAGE_KEY.SCAN_ID);
			}
			if (searchParams.has(PARAMS_NAME.EMAIL) && searchParams.get(PARAMS_NAME.EMAIL) !== "null") {
				userEmail = decodeURIComponent(searchParams.get(PARAMS_NAME.EMAIL)).replace(/ /g, "+");
				setLocalStorage(STORAGE_KEY.EMAIL, userEmail);
			} else {
				userEmail = getLocalStorage(STORAGE_KEY.EMAIL);
			}
		
			if (searchParams.has(PARAMS_NAME.TOKEN) && searchParams.get(PARAMS_NAME.TOKEN) !== "null") {
				await userVerify(REACT_APP_SWAN_API_SERVER_URL, searchParams.get(PARAMS_NAME.TOKEN));
			}
			jwtToken = getLocalStorage(STORAGE_KEY.JWTToken);
			let shopify_redirect_url = `${window.location.origin}${window.location.pathname}`;
			const newSearchString = searchParams.toString();
			if (newSearchString) {
				shopify_redirect_url += `?${newSearchString}`;
			}
			console.log(scanId,"scanid");
			
			// addIframe({ shopDomain, productHandle: product?.handle, jwtToken, shopifyRedirectUrl: shopify_redirect_url });
            setDetails({
                token:jwtToken,email: userEmail,scanID:scanId,
                shopifyRedirectUrl:shopify_redirect_url
            })
			if (searchParams.has(PARAMS_NAME.FIT) && searchParams.has(PARAMS_NAME.CART)) {
				addToCart?.(searchParams.get(PARAMS_NAME.FIT));
			}
		}
	}, [addToCart, attributesData, product?.handle, setDetails, shopDomain,email,name]);

	useEffect(() => {
		initializeAttributesData();
	}, [attributesData, initializeAttributesData]);
  return null
}

export default useGetParams